import React, { createContext, useContext, useMemo, useState } from 'react';

const RoomContext = createContext(null);

export const RoomProvider = ({ children }) => {
	const [roomState, setRoomState] = useState({
		//participants: [],      // array utenti (solo quelli type === 1)
		allCompleted: false,   // tutti hanno finito?
		isPanelOpen: false,    // stato pannello RoomStatus (open/close)
		status: null, // NotStarted, InProgress, Completed
		currentUserPosition: null, // posizione dell'utente corrente nella classifica (1-based)
		roomItemsOrder: null, // ordine corrente dei giocatori (solo sessionId)
	});

	const value = useMemo(() => ({ roomState, setRoomState }), [roomState]);
	return <RoomContext.Provider value={value}>{children}</RoomContext.Provider>;
};

export const useRoom = () => {
	const ctx = useContext(RoomContext);
	if (!ctx) throw new Error('useRoom must be used within <RoomProvider />');
	return ctx;
};